<div class="container" style="height: 100%">
  <div class="chart-container" style="height: 100%">
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="chartOptions"
      style="width: 100%; height: 100%; display: block"
    ></highcharts-chart>
  </div>
</div>
